import { ITestResultItem } from "./ITestResultItem";
import { TestResultDataType } from "./TestResultDataType";

export abstract class BaseTestResultItem implements ITestResultItem {
    abstract type: TestResultDataType;

    when: Date = new Date();
    endDate?: Date;
    isError: boolean = false;
    itemId: string;
    result: string | undefined;
    // we might need to break this up and store separate.
    items: ITestResultItem[] = [];
    hidden?: boolean;

    constructor(itemId: string, result: string | undefined = undefined) {
        this.itemId = itemId;
        this.result = result;
    }
}
